module.exports = () ->
  return {
    restrict: "A"
    scope:
      comment:      "=?comment"
      isDisabled:   "&commentIsDisabled"
      contentType:  "="
      doc:          "&"
      onSave:       "&"

    controller: ($scope, Api) ->
      $scope.forms = {}

      # Editing an existing comment
      $scope.isEditing = false
      # Creating a new comment
      $scope.isNewComment = false
      # Saving a new or existing comment
      $scope.isSaving = false

      # Create a blank comment resource
      createNewComment = (content = "") ->
        new Api.Comment
          content: content
          content_type: $scope.contentType or "projectstarreddocument"
          document_pk: $scope.doc().id

      # Trigger editing mode for existing comments
      $scope.editComment = () ->
        $scope.isEditing = true
        # Wrap the comment object in an Angular resource just in case as it
        # may not satisfy the resource interface
        $scope.transientComment = angular.extend(createNewComment(), $scope.comment)

      $scope.hasName = () ->
        return $scope.comment?.owner? and ($scope.comment.owner.first_name? or $scope.comment.owner.last_name?)

      $scope.hasDate = () ->
        return $scope.comment?.created_date?

      $scope.getModifiedDate = () ->
        if !$scope.comment.modified_date?
          $scope.comment.modified_date = $scope.comment.created_date
        return $scope.comment.modified_date

      $scope.hasComment = () ->
        return $scope.transientComment?.content?.length > 0

      $scope.canSave = () ->
        return $scope.forms.commentForm?.$dirty and not $scope.isSaving and $scope.hasComment()

      # Upsert comment
      $scope.saveComment = () ->
        return unless $scope.canSave()

        $scope.isSaving = true

        save = if $scope.transientComment.id then $scope.transientComment.$update() else $scope.transientComment.$save()
        save.then (comment) ->
          # Pass the 'updated' comment back upstream
          $scope.onSave({comment: comment})

          if $scope.isNewComment
            # Reset form
            $scope.transientComment = createNewComment()
          else
            # Update existing comment to reflect changes
            $scope.comment = comment

          # Remove saving state, and exit editing mode
          $scope.isEditing = false
          $scope.isSaving = false

      # Cancel editing an existing comment
      $scope.cancelComment = () ->
        $scope.isEditing = false

      # New comment
      if !$scope.comment
        $scope.isNewComment = true

        # Hack: watch for changes to `$scope.doc()`, as the initial load of the
        # Comment directive via Document may not contain a valid document object,
        # .i.e. in search results. We can stop updating once a valid ID is
        # present.
        $scope.transientComment = createNewComment()
        unbind = $scope.$watch 'doc().id', (docId) ->
          return if not docId
          $scope.transientComment = createNewComment()
          unbind()

    template: require("./comment.html")
  }
